import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["margin", "marginBlock", "marginBlockEnd", "marginBlockStart", "marginInline", "marginInlineEnd", "marginInlineStart", "padding", "paddingBlock", "paddingBlockEnd", "paddingBlockStart", "paddingInline", "paddingInlineEnd", "paddingInlineStart", "size", "tooltip", "variant"];
import { Tooltip } from './Tooltip';
import { IconInfo } from '../Icons/IconInfo';
import { jsx as _jsx } from "react/jsx-runtime";
export const TooltipInfo = _ref => {
  let {
      margin,
      marginBlock,
      marginBlockEnd,
      marginBlockStart,
      marginInline,
      marginInlineEnd,
      marginInlineStart,
      padding,
      paddingBlock,
      paddingBlockEnd,
      paddingBlockStart,
      paddingInline,
      paddingInlineEnd,
      paddingInlineStart,
      size,
      tooltip,
      variant
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Tooltip, Object.assign({}, rest, {
    tooltip: tooltip,
    children: /*#__PURE__*/_jsx(IconInfo, {
      margin: margin,
      marginBlock: marginBlock,
      marginBlockEnd: marginBlockEnd,
      marginBlockStart: marginBlockStart,
      marginInline: marginInline,
      marginInlineEnd: marginInlineEnd,
      marginInlineStart: marginInlineStart,
      padding: padding,
      paddingBlock: paddingBlock,
      paddingBlockEnd: paddingBlockEnd,
      paddingBlockStart: paddingBlockStart,
      paddingInline: paddingInline,
      paddingInlineEnd: paddingInlineEnd,
      paddingInlineStart: paddingInlineStart,
      size: size,
      variant: variant
    })
  }));
};